

export function getAuthHeaders() {
  const cookieHeader = sessionStorage.getItem('cookieHeader');
  const csrfToken = sessionStorage.getItem('csrfToken');
  return {
    'Cookie': cookieHeader,
    'Content-Type': 'application/json',
    'X-CSRFToken': csrfToken,
  };
}

export function getAuth() {
  const cookieHeader = sessionStorage.getItem('cookieHeader');
  const csrfToken = sessionStorage.getItem('csrfToken');
  
  return {
   'Cookie' :  cookieHeader,
    'X-CSRFToken':csrfToken,
    'Content-Type': 'multipart/form-data',
  };
}